import * as midTermUrl from 'src/helpers/url_helper';
import { apiSlice } from 'src/rtk/api/apiSlice';

export const midTermApi = apiSlice
    .enhanceEndpoints({ addTagTypes: ['MidTerm'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getMidTermCandidatesList: builder.query<APIResponse<any>, string>({
                query: (url) => ({
                    method: 'GET',
                    url: `${midTermUrl.MID_TERM_LIST_FOR_ADMIN}?${url}`,
                }),
                providesTags: ['MidTerm'],
            }),

            getMidtermResultUpdate: builder.mutation<APIResponse<any>, string>({
                query: (url) => ({
                    method: 'GET',
                    url: `${midTermUrl.MID_TERM_RESULT_UPDATE}/${url}`,
                }),
                invalidatesTags: ['MidTerm'],
            }),

            approveProvisionCertificate: builder.mutation<APIResponse<any>, string>({
                query: (registrationNo) => ({
                    method: 'GET',
                    url: `${midTermUrl.PROVISION_CERTIFICATE_APPROVAL}/${encodeURIComponent(registrationNo)}`,
                    params: {
                        provision_certificate_status: 'Approve',
                    },
                }),
                invalidatesTags: ['MidTerm'],
            }),

            getMidTermPassedTraineeList: builder.query<APIResponse<any>, string>({
                query: (url) => ({
                    method: 'GET',
                    url: `${midTermUrl.MID_TERM_PASSED_TRAINEE_LIST}?${url}`,
                }),
                providesTags: ['MidTerm'],
            }),

            midTermResultUpload: builder.mutation<APIResponse<any>, FormData>({
                query: (formData) => ({
                    method: 'POST',
                    url: `${midTermUrl.MID_TERM_RESULT_UPLOAD}`,
                    body: formData,
                }),
                invalidatesTags: ['MidTerm'],
            }),

            fcpsPartOneRecordUpload: builder.mutation<APIResponse<any>, FormData>({
                query: (formData) => ({
                    method: 'POST',
                    url: `${midTermUrl.FCPS_RECORD_UPLOAD}`,
                    body: formData,
                }),
                invalidatesTags: ['MidTerm'],
            }),

        }),
    });

export const {
    useGetMidTermCandidatesListQuery,
    useGetMidtermResultUpdateMutation,
    useApproveProvisionCertificateMutation,
    useGetMidTermPassedTraineeListQuery,
    useMidTermResultUploadMutation,
    useFcpsPartOneRecordUploadMutation,
} = midTermApi;
